import React, { useState, useEffect, useCallback, useRef } from "react";
import { Layout, Popconfirm, notification, message, Space, Modal } from "antd";
import { useNavigate, Link } from "react-router-dom";
import { Button, Row, Form, Input, Col, Select, Collapse } from "antd";

import TopHeader from "../common/TopHeader/TopHeader";
import Sidebar from "../common/Sidebar/Sidebar";
// import FooterDashboard from "../common/FooterDashboard/FooterDashboard";
import QuestionnairesApi from "../common/Apis/QuestionnairesApi";
import Subtenant from "../common/Models/Subtenants/Subtenants";
import { CompassOutlined, DeleteOutlined, EditOutlined, MinusCircleTwoTone, PlusCircleTwoTone, UserSwitchOutlined } from "@ant-design/icons";
import SubtenantApi from "../common/Apis/SubtenantApi";
import CreateSubTenantModal from "./CreateSubTenantModal";
import UpdateSubTenantModal from "./UpdateSubTenantModal";
import DeleteSubTenantConfirmModal from "./DeeteSubTenantConfirmModel";
import ProductApi from "../common/Apis/ProductApi";
import AddAdminUserTenant from "../Pages/CreateUser/AddAdminUserTenant";
import AddAdminUserSubTenant from "../Pages/CreateUser/AddAdminUserSubTenant";
import { createDefaultSubTenant } from "../../models/SubTenant/SubTenantDTO";
import Pagination from "../common/Pagination/Pagination"; 
import "../common/Pagination/Pagination.css"; 

const { confirm } = Modal;

const Subtenants = () => {
  const fileInputRef = useRef(null);
  let navigate = useNavigate();
  const { Content } = Layout;
  const { Panel } = Collapse;
  const [Tenants, setTenants] = React.useState([]);
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const [isCreateSubTenantModalVisible, setCreateSubTenantModalVisible] = useState(false);
  const [isUpdateSubTenantModalVisible, setUpdateSubTenantModalVisible] = useState(false);
  const [selectedTenant, setSelectedTenant] = useState(null);
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [tenantAdminModelVisible, setTenantAdminAddModalVisible] = useState(false);
  const [totalElements, setTotalElements] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  console.log("Decoded Token in Subtenants component:", decodedToken);


  useEffect(() => {
    getTenants();
    PageLoading();
  }, []);

  const handleOpenCreateSubTenantModal = () => {
    setCreateSubTenantModalVisible(true);
  };

  const handleOpenUpdateSubTenantModal = (tenant) => {
    setSelectedTenant(tenant);
    setUpdateSubTenantModalVisible(true);
  };

  const handleCloseCreateSubTenantModal = () => {
    setCreateSubTenantModalVisible(false);
    getTenants();
  };

  const handleCloseUpdateSubTenantModal = () => {
    setUpdateSubTenantModalVisible(false);
    getTenants();
  };

  const navigateToUsersPage = (tenant) => {
    navigate(`/sub-tenants/${tenant.subTenantName.replace(/\s+/g, '-')}/users?id=${tenant.id}`);
  }

  const showDeleteModal = (tenant) => {
    setSelectedTenant(tenant);
    setDeleteModalVisible(true);
  };

  const showDeactivateConfirm = (subTenant) => {
    confirm({
      title: `Are you sure you want to deactivate subtenant "${subTenant.subTenantName}"?`,
      content: "This action can be undone.",
      okText: "Yes, Deactivate",
      okType: "danger",
      cancelText: "Cancel",
      onOk() {
        const payload = createDefaultSubTenant({
          id: subTenant.id,
          subTenantCode: subTenant.subTenantCode,
          subTenantName: subTenant.subTenantName,
          enabled: false,
          tenantDTO: {
            id: decodedToken?.tenantId
          }
        });

        SubtenantApi.PutSubtenant(subTenant?.id, payload)
          .then(() => {
            getTenants();
            notification.open({
              message: (
                <span style={{ fontWeight: "bold" }}>
                  Subtenant deactivated successfully!
                </span>
              ),
              closeIcon: false,
              duration: 3,
              style: {
                backgroundColor: "#b3ffb3",
                color: "green",
              },
            });
          })
          .catch((error) => {
            console.error("Error deactivating tenant:", error);

            notification.open({
              message: (
                <span style={{ fontWeight: "bold" }}>
                  Failed to deactivate tenant
                </span>
              ),
              description: error?.response?.data?.message || "An unexpected error occurred.",
              closeIcon: false,
              duration: 4,
              style: {
                backgroundColor: "#ffcccc",
                color: "red",
              },
            });
          });

        console.log("Deactivating subtenant:", subTenant.id);
      },
      onCancel() {
        console.log("Deactivation cancelled");
      },
    });
  };


  const showActivateConfirm = (subTenant) => {
    confirm({
      title: `Are you sure you want to activate subtenant "${subTenant.subTenantName}"?`,
      content: "This action can be undone.",
      okText: "Yes, Activate",
      okType: "primary",
      cancelText: "Cancel",
      onOk() {
        const payload = createDefaultSubTenant({
          id: subTenant.id,
          subTenantCode: subTenant.subTenantCode,
          subTenantName: subTenant.subTenantName,
          enabled: true,
          tenantDTO: {
            id: decodedToken?.tenantId
          }
        });

        SubtenantApi.PutSubtenant(subTenant?.id, payload)
          .then(() => {
            getTenants();
            notification.open({
              message: (
                <span style={{ fontWeight: "bold" }}>
                  Subtenant activated successfully!
                </span>
              ),
              closeIcon: false,
              duration: 3,
              style: {
                backgroundColor: "#b3ffb3",
                color: "green",
              },
            });
          })
          .catch((error) => {
            console.error("Error deactivating tenant:", error);

            notification.open({
              message: (
                <span style={{ fontWeight: "bold" }}>
                  Failed to deactivate tenant
                </span>
              ),
              description: error?.response?.data?.message || "An unexpected error occurred.",
              closeIcon: false,
              duration: 4,
              style: {
                backgroundColor: "#ffcccc",
                color: "red",
              },
            });
          });

        console.log("Deactivating subtenant:", subTenant.id);
      },
      onCancel() {
        console.log("Deactivation cancelled");
      },
    });
  };

  // const showActivateConfirm = (tenant) => {
  //   confirm({
  //     title: `Are you sure you want to activate subtenant "${tenant.tenantName}"?`,
  //     content: "This action can be undone.",
  //     okText: "Yes, Activate",
  //     okType: "primary",
  //     cancelText: "Cancel",
  //     onOk() {
  //       const payload = createDefaultTenant({
  //         id: tenant.id,
  //         tenantCode: tenant.tenantCode,
  //         tenantName: tenant.tenantName,
  //         enabled: true,
  //         multitenancy: tenant.multitenancy
  //       });

  //       TenantsApi.Edittenants(tenant?.id, payload)
  //         .then(() => {
  //           getTenants();
  //           notification.open({
  //             message: (
  //               <span style={{ fontWeight: "bold" }}>
  //                 Tenant / Customer activated successfully!
  //               </span>
  //             ),
  //             closeIcon: false,
  //             duration: 3,
  //             style: {
  //               backgroundColor: "#b3ffb3",
  //               color: "green",
  //             },
  //           });
  //         })
  //         .catch((error) => {
  //           console.error("Error deactivating tenant:", error);

  //           notification.open({
  //             message: (
  //               <span style={{ fontWeight: "bold" }}>
  //                 Failed to deactivate tenant
  //               </span>
  //             ),
  //             description: error?.response?.data?.message || "An unexpected error occurred.",
  //             closeIcon: false,
  //             duration: 4,
  //             style: {
  //               backgroundColor: "#ffcccc",
  //               color: "red",
  //             },
  //           });
  //         });

  //       console.log("Deactivating tenant:", tenant.id);
  //     },
  //     onCancel() {
  //       console.log("Deactivation cancelled");
  //     },
  //   });
  // };

  const closeDeleteModal = () => {
    setDeleteModalVisible(false);
    setSelectedTenant(null);
    getTenants();
  };

  // const handleSaveSubTenant = (values) => {
  //   setCreateSubTenantModalVisible(false);
  // };
  const PageLoading = useCallback(() => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 800);
  }, []);
  const getTenants = useCallback(() => {
    SubtenantApi.subtenantsList(decodedToken?.tenantId)
      .then((response) => {
        setTenants(response.payloadDto);
        setTotalElements(response.totalElements);
        setTotalPages(response.totalPages);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const formRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleRemovefilterTenant = (FilterTenantIndex) => {
    const newfilterTenant = [...filterTenant];
    newfilterTenant.splice(FilterTenantIndex, 1);
    setFilterTenants(newfilterTenant);
    if (FilterTenantIndex == 0) {
      getTenants();
    }
  };
  const handleClear = () => {
    getTenants();
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 800);
    setFilterTenants([
      {
        title: "",
        answerType: "",
        name: "",
      },
    ]);
  };

  const [filterTenant, setFilterTenants] = useState([
    {
      title: "",
      answerType: "",
      name: "",
    },
  ]);

  const handleAddfilterTenants = () => {
    setFilterTenants([
      ...filterTenant,
      {
        title: "",
        answerType: "",
        name: "",
      },
    ]);
  };

  const handleSubmit = (data) => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 800);
    let singleLineString = filterTenant
      .map((obj) => {
        if (obj.answerType === "%") {
          return `${obj.title}=${obj.answerType}${obj.name}${obj.answerType}`;
        } else if (obj.answerType === "=") {
          return `${obj.title}${obj.answerType}${obj.name}`;
        } else {
          return `${obj.title}=BETWEEN${createDateTimestamp(
            obj.answerType
          )}AND${createDateTimestamp(obj.name)}`;
        }
      })
      .join("&");


    let filderData = window.btoa("componentCode=SUB_TENANT&subTenant.id=" + decodedToken?.subTenantId + "&" + singleLineString);
    QuestionnairesApi.FilterQuestionsetNext(filderData, 0, 100)
      .then((response) => {
        setTenants(response.payloadDto);
      })
      .catch((err) => { });
  };
  const createDateTimestamp = (Cdate) => {
    const date = new Date(Cdate);
    const unixTime = Math.floor(date.getTime());
    return unixTime;
  };
  const handleChangeTitle = (filterTenantIndex, value) => {
    const newfilterTenant = [...filterTenant];
    newfilterTenant[filterTenantIndex].title = value;
    setFilterTenants(newfilterTenant);
  };
  const handleChangeAnswertype = (filterTenantIndex, value) => {
    const newfilterTenant = [...filterTenant];
    newfilterTenant[filterTenantIndex].answerType = value;
    setFilterTenants(newfilterTenant);
  };

  const handleChangename = (filterTenantIndex, value) => {
    const newfilterTenant = [...filterTenant];
    newfilterTenant[filterTenantIndex].name = value;
    setFilterTenants(newfilterTenant);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const paginatedData = Tenants.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  const exportProductSheet = (item) => {
    ProductApi.ExportProducts(item?.id).catch((err) => {
      console.log(err);
    });
  }

  const importProductSheet = (item) => {
    setSelectedTenant(item);
    fileInputRef.current.click();
  }

  const showTenantAdminUserAddModal = (tenant) => {
    // console.log("tenant id " + tenant?.id);
    setSelectedTenant(tenant);
    setTenantAdminAddModalVisible(true);
  }

  const handleProductFileChange = (e, item) => {
    const file = e.target.files[0];
    if (file) {
      ProductApi.ImportProducts(file, selectedTenant?.id)
        .then((res) => {
          notification.open({
            message: <span style={{ fontWeight: "bold" }}>File Imported Successfully !</span>,
            closeIcon: false,
            duration: 3,
            style: {
              backgroundColor: "#b3ffb3",
              color: "green",
            },
          });
        })
        .catch((err) => {
          console.error("❌ Import failed:", err);
        });
    }

    // reset input so same file can be selected again if needed
    e.target.value = "";
  };

  const switchToSubtenant = (item) => {
    // 1. Set localStorage key
    localStorage.setItem("switched", "true");
    localStorage.setItem("switchedSubtenant", JSON.stringify(item));

    // Optional: show a success message
    message.success(`Switched to ${item.subTenantName}`);

    // 2. Navigate to /dashboard and reload
    navigate("/dashboard"); // same tab navigation with reload
    window.location.reload();
  }

  const renderTableRows = () => {
    return paginatedData.map((item) => (
      <tr key={item.id} className="text-center" style={{
        background: item.enabled === false ? "#ffcccc" : "transparent", padding: '0px'
      }}>
        <td>{item.subTenantCode}</td>
        <td>{item.subTenantName}</td>
        <td style={{ width: "20%" }}>
          <div className="d-flex justify-content-center align-items-center">
            <div className="dropdown">
              <Button
                type="default"
                className="dropdown-toggle"
                id={`actionMenu-${item.id}`}
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Actions
              </Button>
              <ul
                className="dropdown-menu"
                aria-labelledby={`actionMenu-${item.id}`}
              >
                <li>
                  {/* <Link
                                  className="dropdown-item"
                                  to={`/tenants/users?id=${item.id}`}
                                >
                                  Users
                                </Link> */}
                  <Button
                    type="button"
                    className="dropdown-item"
                    onClick={() => navigateToUsersPage(item)}
                  >
                    Users
                  </Button>
                </li>
                <li>
                  <Button
                    type="button"
                    className="dropdown-item"
                    onClick={() => exportProductSheet(item)}
                  >
                    Export Product Excel Sheet
                  </Button>
                </li>
                <li>
                  <Button
                    type="button"
                    className="dropdown-item"
                    onClick={() => importProductSheet(item)}
                  >
                    Import Product Excel Sheet
                  </Button>
                  <input
                    type="file"
                    accept=".xlsx,.xls"
                    ref={fileInputRef}
                    style={{ display: "none" }}
                    onChange={(e) => handleProductFileChange(e, item)}
                  />
                </li>
                {/* <li>
                  <Button
                    type="button"
                    className="dropdown-item"
                  onClick={() => showTenantAdminUserAddModal(item)}
                  >
                    Add an admin
                  </Button>
                </li> */}
                <li>
                  <Button
                    type="button"
                    className="dropdown-item"
                    onClick={() => switchToSubtenant(item)}
                  >
                    Switch to this shop
                  </Button>
                </li>
                <li>
                  <Button
                    type="button"
                    className="dropdown-item"
                    onClick={() => handleOpenUpdateSubTenantModal(item)}
                  >
                    Edit Shop/Store Details
                  </Button>
                </li>
                {item.enabled === false && <li>
                  <Button
                    type="button"
                    className="dropdown-item"
                    onClick={() => showDeleteModal(item)}
                  >
                    Delete Shop/Store
                  </Button>
                </li>}
                {item.enabled === false && <li>
                  <Button
                    type="button"
                    className="dropdown-item"
                  onClick={() => showActivateConfirm(item)}
                  >
                    Activate Shop/Store
                  </Button>
                </li>}
                {item.enabled !== false && <li>
                  <Button
                    type="button"
                    className="dropdown-item"
                    onClick={() => showDeactivateConfirm(item)}
                  >
                    Deactivate Shop/Store
                  </Button>
                </li>}
              </ul>
            </div>
            {/* <Space>
              <Button
                color="purple"
                variant="solid"
                onClick={() => {
                  // 1. Set localStorage key
                  localStorage.setItem("switched", "true");
                  localStorage.setItem("switchedSubtenant", JSON.stringify(item));

                  // Optional: show a success message
                  message.success(`Switched to ${item.subTenantName}`);

                  // 2. Navigate to /dashboard and reload
                  window.location.href = "/dashboard"; // same tab navigation with reload
                }}
              >
                Switch
              </Button>
              <Button type="primary" onClick={() => navigateToUsersPage(item)}>Users</Button>
              <Button type="default" onClick={() => handleOpenUpdateSubTenantModal(item)}>Edit</Button>
              <Button color="danger" variant="filled" onClick={() => showDeleteModal(item)}>Delete</Button>
            </Space> */}
          </div>
          {/* <div className="d-flex ">
            <Link
              to={`/sub-tenants/edit-sub-tenants?id=${item?.id}`}
              className={decodedToken?.permissions?.some(
                (permission) => permission?.authority === 'EDIT_SUB_TENANT'
              ) ? 'btn btn-primary btn-save table-action icon-center w-100' : 'd-none'}
            >
              <EditOutlined />
              Edit
            </Link>
            <Link
              to={`/sub-tenants/${item.subTenantName.replace(/\s+/g, '-')}/users?id=${item.id}`}
              className={decodedToken?.permissions?.some(
                (permission) => permission?.authority === 'EDIT_SUB_TENANT'
              ) ? 'btn btn-primary btn-save table-action icon-center mx-1 w-100' : 'd-none'}
            >
              <UserSwitchOutlined />
              Users
            </Link>
            <Popconfirm
              title="Are you sure ?"
              description="Do you really want to delete this Subtenants ?"
              okText="Yes"
              onConfirm={() => handleDeleteSubtenants(item.id)}
              placement="topRight"
              className="w-100"
              cancelText="No"
            >
              <Link
                to={``}
                className={decodedToken?.permissions?.some(
                  (permission) => permission?.authority === 'DELETE_SUB_TENANT'
                ) ? 'btn btn-primary btn-back table-action icon-center ' : 'd-none'}
              >
                <DeleteOutlined />
                Delete
              </Link>
            </Popconfirm>
          </div> */}

        </td>
      </tr >
    ));
  };

  const handleDeleteSubtenants = (SubtenantID) => {
    SubtenantApi.DeletesubtenantsApi(SubtenantID)
      .then((response) => {
        notification.open({
          message: <span style={{ fontWeight: "bold" }}>Deleted</span>,
          description: "Delete Successfully",
          closeIcon: false,
          duration: 3,
          style: {
            backgroundColor: "#b3ffb3",
            color: "green",
          },
        });
        getTenants();
        PageLoading();
      })
      .catch((err) => {
        if (err.apiError.status) {
          notification.open({
            message: <span style={{ fontWeight: "bold" }}>Error</span>,
            description: err.apiError.message,
            closeIcon: false,
            duration: 3,
            style: {
              backgroundColor: "#fff2f0",
              color: "red",
            },
          });
        }
      });
  }; 


  const [modalVisible, setModalVisible] = useState(false);

  const handleOpenAddModal = () => {
    setModalVisible(true);
  };

  const handlCloseModal = () => {
    setModalVisible(false);
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar />

      <Layout>
        <TopHeader />
        {isLoading && (
          <div className="spinner-overlay" id="spinnerOverlay">
            <div className="spinner"></div>
          </div>
        )}

        <div
          style={{
            padding: "20px",
            paddingBottom: "5px",
          }}
        >
          <Form
            ref={formRef}
            name="nest-messages"
            layout="vertical"
            className="FormClass "
            onFinish={handleSubmit}
          >
            <>
              <Collapse>
                <Panel
                  header={
                    <h5 className="mb-0">
                      <b>Filter</b>
                    </h5>
                  }
                  key="1"
                >
                  {filterTenant.map((input, filterTenantIndex) => (
                    <div key={filterTenantIndex}>
                      <Row gutter={12}>
                        <Col span={5}>
                          <Form.Item
                            name={`title${filterTenantIndex}`}
                            className="text-lable"
                            rules={[
                              {
                                required: true,
                                message: "Please Select",
                              },
                            ]}
                          >
                            <Select
                              className="control-Select"
                              placeholder="Filter By"
                              value={input.title}
                              onChange={(value) =>
                                handleChangeTitle(filterTenantIndex, value)
                              }
                              options={[
                                { value: "subTenantCode", label: "Code" },
                                {
                                  value: "subTenantName",
                                  label: "Name",
                                },
                              ]}
                            />
                          </Form.Item>
                        </Col>
                        <Col span={4}>
                          {filterTenant[filterTenantIndex].title ==
                            "createdDate" ? (
                            <>
                              <Form.Item
                                name={`nameto${filterTenantIndex}`}
                                className="text-lable"
                                rules={[
                                  {
                                    required: true,
                                    message: "Please Select Start Date.",
                                  },
                                ]}
                              >
                                <Input
                                  type="date"
                                  placeholder="Filter By"
                                  onChange={(e) =>
                                    handleChangeAnswertype(
                                      filterTenantIndex,
                                      e.target.value
                                    )
                                  }
                                  className="control-input"
                                />
                              </Form.Item>
                            </>
                          ) : (
                            <>
                              <Form.Item
                                name={`type${filterTenantIndex}`}
                                className="text-lable"
                                rules={[
                                  {
                                    required: true,
                                    message: "Please Select type.",
                                  },
                                ]}
                              >
                                <Select
                                  className="control-Select mb-1"
                                  placeholder="Condition"
                                  onChange={(value) =>
                                    handleChangeAnswertype(
                                      filterTenantIndex,
                                      value
                                    )
                                  }
                                  options={[
                                    { value: "%", label: "Matches with" },
                                    {
                                      value: "=",
                                      label: "Equals to",
                                    },
                                  ]}
                                />
                              </Form.Item>
                            </>
                          )}
                        </Col>
                        <Col span={5}>
                          {filterTenant[filterTenantIndex].title ==
                            "createdDate" ? (
                            <>
                              <Form.Item
                                name={`name${filterTenantIndex}`}
                                className="text-lable"
                                rules={[
                                  {
                                    required: true,
                                    message: "Please Select End Date.",
                                  },
                                ]}
                              >
                                <Input
                                  type="date"
                                  onChange={(e) =>
                                    handleChangename(
                                      filterTenantIndex,
                                      e.target.value
                                    )
                                  }
                                  placeholder="Text"
                                  className="control-input"
                                />
                              </Form.Item>
                            </>
                          ) : (
                            <>
                              <Form.Item
                                name={`name${filterTenantIndex}`}
                                className="text-lable"
                                rules={[
                                  {
                                    required: true,
                                    message: "Please enter Text.",
                                  },
                                ]}
                              >
                                <Input
                                  type="text"
                                  onChange={(e) =>
                                    handleChangename(
                                      filterTenantIndex,
                                      e.target.value
                                    )
                                  }
                                  placeholder="Text"
                                  className="control-input"
                                />
                              </Form.Item>
                            </>
                          )}
                        </Col>

                        <Col span={8}>
                          <Form.Item className="text-lable">
                            {filterTenantIndex == 0 ? (
                              <>
                                <Row gutter={23} className="mb-3">
                                  <Col span={2} className="mx-0">
                                    <Form.Item className="text-lable">
                                      <PlusCircleTwoTone
                                        onClick={handleAddfilterTenants}
                                      />
                                    </Form.Item>
                                  </Col>

                                  <Col span={10}>
                                    <Button
                                      type="primary"
                                      htmlType="submit"
                                      className="btn btn-primary btn-save table-action icon-center "
                                    >
                                      Filter
                                    </Button>
                                  </Col>
                                  <Col span={10}>
                                    <Button
                                      type="reset"
                                      htmlType="reset"
                                      onClick={() => handleClear()}
                                      style={{ color: "#0b5ed7" }}
                                      className="btn btn-primary btn-back table-action icon-center"
                                    >
                                      Clear
                                    </Button>
                                  </Col>
                                </Row>
                              </>
                            ) : (
                              <>
                                {" "}
                                <MinusCircleTwoTone
                                  onClick={() =>
                                    handleRemovefilterTenant(filterTenantIndex)
                                  }
                                />
                              </>
                            )}
                          </Form.Item>
                        </Col>
                      </Row>
                    </div>
                  ))}
                </Panel>
              </Collapse>
            </>
          </Form>
        </div>
        <Content
          className="form-content nav-content"
          style={{
            margin: "14px 16px 0",
            padding: "30px",
            background: "white",
          }}
        >
          <div>
            {/* <Button
              href={"/sub-tenants/add-sub-tenants"}
              className={decodedToken?.permissions?.some(
                (permission) => permission?.authority === 'ADD_SUB_TENANT'
              ) ? 'btn btn-primary btn-save m-0 my-2' : 'd-none'}
            >
              Add Sub Tenants
            </Button> */}
            {decodedToken.roles[0] === "SUPER_ADMIN" && (
              <Button type="primary" style={{ padding: '5px 24px', fontSize: '18px' }} onClick={() => handleOpenCreateSubTenantModal()}>
                Add New Store / Shop
              </Button>
            )}
            <table className="table Tenants-table">
              <thead>
                <tr>
                  <th>Code</th>
                  <th>Name</th>
                  <th className="text-center"></th>
                </tr>
              </thead>
              <tbody>{renderTableRows()}</tbody>
            </table>
            {paginatedData.length > 0 && (
            <Pagination
              currentPage={currentPage}
              totalPages={Math.ceil(Tenants.length / pageSize)}
              onPageChange={handlePageChange}
              maxVisiblePages={5}
              showPageInfo={true}
              totalItems={Tenants.length}
              pageSize={pageSize}
            />
          )}
          </div>
        </Content>
        {/* <Subtenant
          visible={modalVisible}
          onClose={handlCloseModal}
        /> */}
        <CreateSubTenantModal
          visible={isCreateSubTenantModalVisible}
          onCancel={handleCloseCreateSubTenantModal}
          tenantId={decodedToken?.tenantId}
        />
        <UpdateSubTenantModal
          visible={isUpdateSubTenantModalVisible}
          onCancel={handleCloseUpdateSubTenantModal}
          tenant={selectedTenant}
        />
        <DeleteSubTenantConfirmModal
          visible={deleteModalVisible}
          subTenant={selectedTenant}
          onCancel={closeDeleteModal}
        />
        <AddAdminUserSubTenant
          open={tenantAdminModelVisible}
          onClose={() => setTenantAdminAddModalVisible(false)}
          tenantId={selectedTenant?.id}
        />
        {/* <FooterDashboard /> */}
      </Layout>
    </Layout>
  );
};

export default Subtenants;
